/**
 * ! FIXME: create prop to occupy all width to resolve style issues of
 * `<ShareCampaignLoginModal />`
 */
import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import AppleLogin from 'components/SocialLogin/AppleLogin';
import FacebookLogin from 'components/SocialLogin/FacebookLogin';
import GoogleLogin from 'components/SocialLogin/GoogleLogin';

const SocialMediaLoginButtonsGroup = ({
  className,
  gaEventCategory,
  appleLoginButtonProps = {},
  googleLoginButtonProps = {},
  facebookLoginButtonProps = {},
  ...rest
}) => (
  <div
    className={twMerge('flex h-10 items-center justify-center', className)}
    {...rest}
  >
    <GoogleLogin
      data-test-selector="login-google"
      gaEventCategory={gaEventCategory}
      {...googleLoginButtonProps}
    />
    <FacebookLogin
      className="ml-3 mr-4"
      data-test-selector="login-facebook"
      gaEventCategory={gaEventCategory}
      {...facebookLoginButtonProps}
    />
    <AppleLogin gaEventCategory={gaEventCategory} {...appleLoginButtonProps} />
  </div>
);

SocialMediaLoginButtonsGroup.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  gaEventCategory: PropTypes.string.isRequired,
  appleLoginButtonProps: PropTypes.shape({
    onSuccess: PropTypes.func,
  }),
  googleLoginButtonProps: PropTypes.shape({
    onSuccess: PropTypes.func,
  }),
  facebookLoginButtonProps: PropTypes.shape({
    onSuccess: PropTypes.func,
  }),
};

export default SocialMediaLoginButtonsGroup;
